import { load } from 'cheerio';
import { Element } from 'domhandler';
import { v4 as uuidv4 } from 'uuid';

export const parseHeaderTags = (html: string | undefined): ParsedNode[] => {
  if (!html) return [];
  const $ = load(html);
  return $('script,link,meta,style')
    .toArray()
    .map((el: Element) => {
      return {
        id: uuidv4(),
        content: $(el).html(),
        tagName: el.tagName,
        props: attributesToProps(el.attributes),
      };
    });
};

export const attributesToProps = (attributes: HtmlAttribute[]): Record<string, unknown> => {
  return attributes.reduce((acc, current) => {
    if (!current.value) return acc;
    return { ...acc, [current.name]: current.value };
  }, {});
};

export interface ParsedNode {
  props: Record<string, unknown>;
  tagName: string;
  content: string | null;
}

export interface HtmlAttribute {
  name: string;
  value: string;
  namespace?: string;
  prefix?: string;
}
